// Global Components
import * as React from 'react';

// Components
import InputLabel from '../InputLabel';

// Types
import type {
  $InputProps,
} from '../../../types';

type $OptionalProps = {
  className?: string;
  disabled?: boolean;
  label?: string;
  labelClassName?: string;
  max?: null | number;
  min?: null | number;
  onChange?: (value: string) => unknown;
  placeholder?: string;
  required?: boolean;
  value?: null | number;
};

type $Props = $InputProps & $OptionalProps & {
  highlight: boolean;
  name: string;
};

class InputTextView extends React.Component<$Props> {
  static defaultProps: $OptionalProps = {
    className: undefined,
    disabled: undefined,
    label: undefined,
    labelClassName: undefined,
    max: undefined,
    min: undefined,
    onChange: undefined,
    placeholder: undefined,
    required: undefined,
    value: undefined,
  };

  getMinMax(): {
    max?: number;
    min?: number;
    } {
    const {
      max,
      min,
    } = this.props;

    const output: {
      max?: number;
      min?: number;
    } = {
      max: undefined,
      min: undefined,
    };

    if (max !== null) {
      output.max = max;
    }

    if (min !== null) {
      output.min = min;
    }

    return output;
  }

  renderInput() {
    const {
      disabled,
      highlight,
      isValid,
      name,
      onChange,
      placeholder,
      required,
      setValue,
      value,
    } = this.props;

    const {
      max,
      min,
    } = this.getMinMax();

    return (
      <input
        className={`border-${highlight && !isValid ? 'red-600' : 'gray-400'} text-sm sm:text-base placeholder-gray-600 p-2 rounded-lg border w-full focus:outline-none focus:border-blue-400`}
        disabled={disabled}
        id={name}
        max={max}
        min={min}
        name={name}
        onChange={(e) => {
          const newValue = e.currentTarget.value;

          if (onChange) {
            onChange(newValue);
          }

          setValue(newValue);
        }}
        placeholder={placeholder}
        required={required}
        type={'number'}
        value={value || undefined}
      />
    );
  }

  render() {
    const {
      className,
      label,
      labelClassName,
      name,
      required,
    } = this.props;

    return (
      <div className={`InputNumber ${className || ''}`}>
        <InputLabel
          className={labelClassName}
          label={label}
          name={name}
          required={required}
        />
        {this.renderInput()}
      </div>
    );
  }
}

export default InputTextView;
